import React, { FC, useMemo } from 'react'
import './payment-method-brand.css'

// UTILITIES
import { flatten } from '@utils/string-helper'


interface Props extends React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement> {
    brand?: string,
    height?: string,
    width?: string
}

const PaymentMethodBrand: FC<Props> = (props) => {
    const { className: classProps, brand = 'unknown', height = '4rem', width = '4rem', ...imgProps } = props
    const className = flatten("payment-method-brand", classProps)
    const brandName = useMemo(() => {
        switch (brand) {
            case 'amex': return 'amex.svg'
            case 'discover': return 'discover.svg'
            case 'mastercard': return 'mastercard.svg'
            case 'mastercard-icon': return 'mastercard-icon.svg'
            case 'visa': return 'visa.svg'
            case 'apple_pay': return 'apple_pay.svg'
            case 'google_pay': return 'google_pay.svg'
            case 'splitcard-credit': return 'splitcard_credit.svg'
            default: return 'unknown.svg'
        }
    }, [brand])

    return <div style={{ width: width, height: height, borderRadius: '50%', justifyContent: 'center', alignContent: 'center' }}>
        <img className={className} src={`/payment-brands/${brandName}`} alt={brand} {...imgProps} />
    </div>
}

export default PaymentMethodBrand
